export default "__VITE_ASSET__DtPl_cgS__"